import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Article = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Article' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M16,7 L19,7 L19,11 L16,11 L16,7 Z M9,15 L20,15 M9,11 L13,11 M9,7 L13,7 M6,18.5 C6,19.8807119 4.88071187,21 3.5,21 C2.11928813,21 1,19.8807119 1,18.5 L1,7 L6.02493781,7 M6,18.5 L6,3 L23,3 L23,18.5 C23,19.8807119 21.8807119,21 20.5,21 L3.5,21' />
  </StyledIcon>
);
